<template>
  <a  v-in-viewport class="animatedbutton"
    ><slot></slot>
   </a>
</template>

<script>
import { TweenMax, DrawSVGPlugin } from "gsap";
// import ScrollMagic from

export default {
  name: "AnimatedButton",
  props:["to"]
 
};
</script>

<style></style>
